<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" title=""></PageHeader>
        <b-container class="bg-white p-3 p-md-5 mt-5 mt-sm-2 shadow-sm rounded ">
            <div class="text-center">
                <h3 class="text-center my-5">邀請碼</h3>
                <p v-if="false">分享給與您接觸的推廣人員，待推廣人員設定好，會提醒您點擊上方選單禮物圖示進行優惠方案購買。</p>
            </div>
            <b-card no-body class="overflow-hidden mx-auto shadow border-0 py-5" >
                <p class="text-center  text-primary">您的專屬邀請碼</p>
                <h2 class="text-center text-black-50">{{ promotionCode }}</h2>


            </b-card>

        </b-container>

    </div>


</template>
<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'


export default {
  name: 'login',
  components: {Nav,PageHeader},
  data () {
    return {

    }
  },
  computed:{
    ...mapState(['login','profiledata']),
    promotionCode:function () {return this.profiledata !==null ? this.profiledata.invite_num : '0';},
  },
  methods: {

  }
}
</script>
